import { DynamicField } from "./dynamic-field.model";

export class DynamicTextarea<T> extends DynamicField<T> {


    rows?: number;

    constructor(source: Partial<DynamicTextarea<T>>) {
        super();
        Object.assign(this, source);
    }
}